<template>
  <el-dialog title="售后申请" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh" width="1000px">
    <div class="input-box">
      <el-input v-model="inputVal" placeholder="搜索售后号" prefix-icon="el-icon-search"></el-input>
      <el-button type="primary" size="small">搜索</el-button>
    </div>
    <div class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
      <div class="cont-box">
        <div class="list-box">
          <div class="list" v-for="(item,index) in salesOptions" :key="index">
            <div class="order-no">
              售后号 <span class="no">{{item.orderNum}}</span> <i class="el-icon-copy-document" style="cursor: pointer;" @click="handleCopy(item)"></i>
              <div class="icon-rig"><em>{{getOrderStaus(item.state)}}</em><span @click="handleActive(item)"><i :class="item.active?'el-icon-arrow-down':'el-icon-arrow-up'"></i></span></div>

            </div>
            <div class="order-info">
              <div>
                <span>申请原因：</span>
                <p>{{item.applyReason}}</p>
              </div>
              <template v-if="!item.active">
                <div>
                  <span>申请时间：</span>
                  <p>{{item.applyTime}}</p>
                </div>
                <div>
                  <span>备注：</span>
                  <p>{{item.applyRamark}}</p>
                </div>
                <div>
                  <span>售后商品：</span>
                  <p><em v-for="(it,idx) in item.goods" :key="idx">{{it.afterGoodsName}}x{{it.afterGoodsCount}};</em></p>
                </div>
                <div>
                  <span>凭证：</span>
                  <p class="">
                    <template v-if="item.voucherUrl">
                      <img v-for="(it,idx) in item.voucherUrl.split(',')" :key="idx" :src="it" />
                    </template>
                  </p>
                </div>
              </template>
            </div>
            <div class="send fr"><el-button type="primary" size="small" @click="handleSend(item)">发送</el-button></div>
          </div>
        </div>
      </div>
      <el-empty description="暂无数据" v-if="!salesOptions.length"></el-empty>
    </div>
  </el-dialog>
</template>

<script>
import goodsOrderApi from '@/api/order/goodsOrder'

export default {
  props: ['currentUser'],
  data() {
    return {
      formVisible: false,
      salesOptions: [],
      inputVal: ''
    }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 200;
  },
  methods: {
    handleSend(item) {
      this.$emit('created', item, 6)
      this.formVisible = false;
    },
    handleActive(item) {
      item.active = !item.active;
      this.$forceUpdate()
    },
    handleShow() {
      this.getSalesList()
    },
    getSalesList() {
      goodsOrderApi.getForList({ isGetGoods: true, orderNum: this.inputVal, customerId: this.currentUser.toUserInfoId }).then(({ data }) => {
        this.salesOptions = data
        this.formVisible = true;
      })
    },
    handleCopy(item) {
      var input = document.createElement('input')
      input.value = item.orderNum;
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success("复制成功");
    },
    getOrderStaus(state) {
      let stateName = ''
      switch (state) {
        case -1:
          stateName = '已取消';
          break;
        case 1:
          stateName = '待审核';
          break;
        case 2:
          stateName = '待寄回商品';
          break;
        case 3:
          stateName = '待收货';
          break;
        case 4:
          stateName = '待确认';
          break;
        case 5:
          stateName = '已完成';
          break;
        case 6:
          stateName = '申请驳回';
          break;
        case 7:
          stateName = '售后驳回';
          break;
        case 8:
          stateName = '待支付';
          break;
      }
      return stateName
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 10px 0;
}
.cont-box {
  padding: 10px 20px;
  .list-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .list {
      width: 48%;
      border: 1px solid #f3f3f3;
      border-radius: 6px;
      margin-bottom: 20px;
      .order-no {
        background: #f3f3f3;
        padding: 14px 15px;
        border-radius: 6px 6px 0 0;
        position: relative;
        .no {
          color: #1596cd;
          padding-right: 25px;
          padding-left: 10px;
        }
        .icon-rig {
          display: inline-block;
          float: right;
          em {
            margin-right: 33px;
            font-style: normal;
          }
          span {
            width: 42px;
            height: 44px;
            line-height: 50px;
            display: inline-block;
            background: #dcdcdc;
            position: absolute;
            right: 0;
            top: 0;
            border-radius: 6px 6px 0 0;
            text-align: center;
            cursor: pointer;
            i {
              font-size: 20px;
            }
          }
        }
      }
      .order-info {
        padding: 0 15px;
        div {
          font-size: 14px;
          color: #999;
          padding: 9px 0;
          span {
            width: 70px;
            display: inline-block;
            text-align: justify;
            text-align-last: justify;
            text-justify: distribute-all-lines;
          }
          p {
            display: inline-block;
            margin: 0;
            vertical-align: top;
            width: calc(100% - 90px);
            em{
              font-style: normal;
              margin-right: 10px;
            }
            img {
              width: 70px;
              height: 70px;
              border-radius: 10px;
              margin-right: 8px;
            }
          }
        }
      }
      .send {
        padding: 10px 15px;
      }
    }
  }
}
.input-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  .el-button {
    margin: 0 10px;
  }
}
.ipt-box {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  padding-right: 20px;
  i {
    font-size: 16px;
    cursor: pointer;
  }
}
::v-deep .el-icon-plus,
.el-icon-minus {
  margin-left: 4px;
  color: #60b7dc;
}
.ipt-box:last-child {
  margin-bottom: 0;
}

.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}
::v-deep .date1 .el-input--prefix .el-input__inner {
  padding-left: 0;
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
</style>
